<template>
  <footer
    class="p-2 bg-white flex flex-col items-center dark:bg-gray-800 mt-auto"
  >
    <slot />

    <!-- «nedicom» здесь было ссылкой на главную: 12-пиксельный текст внутри строки
         невозможно сделать пригодным для нажатия пальцем, а ссылка на главную и так
         есть в логотипе шапки. Оставили текстом. -->
    <span
      class="text-xs md:w-2/3 mb-1 pb-1 text-gray-500 md:text-center border-b"
      >© 2026 nedicom™. Права на товарный знак зарегистрированы в Роспатенте
    </span>

    <!-- На мобильном ссылки идут столбиком: в одну строку они получались высотой
         в 16 пикселей и стояли вплотную — попасть пальцем в нужную было нельзя. -->
    <ul
      class="flex flex-col sm:flex-row sm:flex-wrap list-none w-full sm:w-auto
             items-stretch sm:items-center justify-center mt-1 text-xs text-gray-500"
    >
      <li>
        <!-- Контентный раздел, а не служебная страница: ссылка обычная, без
             nofollow, — по ней робот и должен уходить в базу практики. -->
        <a href="/sudebnaya-praktika"
          class="flex items-center justify-center min-h-[44px] px-3 rounded-lg hover:underline hover:bg-gray-50 transition-colors"
          >Судебная практика</a>
      </li>
      <li>
        <a href="/policy" rel="nofollow noopener noreferrer"
          class="flex items-center justify-center min-h-[44px] px-3 rounded-lg hover:underline hover:bg-gray-50 transition-colors"
          >Политика в отношении персональных данных</a>
      </li>
      <li>
        <a href="/cookie" rel="nofollow noopener noreferrer"
          class="flex items-center justify-center min-h-[44px] px-3 rounded-lg hover:underline hover:bg-gray-50 transition-colors"
          >Правила обработки cookie</a>
      </li>
      <li>
        <a href="/oferta" rel="nofollow noopener noreferrer"
          class="flex items-center justify-center min-h-[44px] px-3 rounded-lg hover:underline hover:bg-gray-50 transition-colors"
          >Оферта</a>
      </li>
      <li>
        <a href="/personal" rel="nofollow noopener noreferrer"
          class="flex items-center justify-center min-h-[44px] px-3 rounded-lg hover:underline hover:bg-gray-50 transition-colors"
          >Согласие на обработку персональных данных</a>
      </li>
      <li>
        <a href="/contacts"
          class="flex items-center justify-center min-h-[44px] px-3 rounded-lg hover:underline hover:bg-gray-50 transition-colors"
          >Контакты</a>
      </li>
    </ul>
  </footer>
</template>
